import React from 'react';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import TextContent from 'components/consumer/TextContent';

const ImageAndContent = ({
  config: {
    elementAttribute,
    imageComponent,
    componentSelection,
    textContentSection,
    buttonSection,
  },
  columnMode = false,
  isMobile = false,
}) => {
  // container config
  const layoutSize = imageComponent?.size ?? 'Full Width';
  const containerBackground =
    componentSelection?.componentSelectionConfig?.backgroundColor;
  const finalOrientation =
    componentSelection?.componentSelectionConfig?.textOrientation === 'Left'
      ? 'default'
      : 'alt';
  const imageUrl = componentSelection?.imageUrl ?? '';
  const hasTextTitleOrBody =
    textContentSection?.title?.text?.length > 0 ||
    textContentSection?.body?.text?.length > 0;

  return (
    <div
      className={classNames('w-full flex flex-col justify-start', {
        'px-5 md:px-[3.333vw] min-[1500px]:px-[50px]':
          !columnMode && layoutSize === 'Full Page',
        // A width of 48% is used for mobile since in testing it consistently provided better spacing than 50%
        // when displaying two columns side by side
        '!w-[48%] flex-shrink-0': isMobile && columnMode,
      })}
    >
      <div
        className={classNames(
          'flex justify-between [&_a:hover]:underline',
          'mx-auto my-0 py-0',
          {
            'flex-row max-[767px]:flex-col !pl-0':
              finalOrientation === 'default',
            'flex-row-reverse max-[767px]:flex-col !pr-0':
              finalOrientation === 'alt',
            'w-full': layoutSize === 'Full Width',
            'max-w-[1400px]': layoutSize === 'Full Page',
            '!flex-col': columnMode,
          }
        )}
        style={{
          backgroundColor: containerBackground ?? '',
        }}
        id={elementAttribute?.id}
      >
        <div>
          <JBImage className="w-full" height={800} width={800} src={imageUrl} />
        </div>

        <div
          className={classNames(
            'max-[767px]:w-full [&_img]:w-full [&_img]:align-middle [&_img]:[transition:all_.25s_ease-in-out] flex flex-row !m-0',
            'grow',
            {
              'px-5 md:px-[12%]': !columnMode,
              'max-[767px]:pt-6':
                finalOrientation === 'default' || finalOrientation === 'alt',
              'w-1/2': !columnMode,
              'py-5 md:py-[3.333vw] min-[1500px]:py-[50px]': hasTextTitleOrBody,
              '!py-0 pb-4': !hasTextTitleOrBody,
            }
          )}
        >
          <TextContent
            config={{
              imageComponent,
              backgroundSelection: {
                backgroundColor:
                  componentSelection?.componentSelectionConfig?.backgroundColor,
              },
              textContentSection,
              buttonSection,
            }}
            variant={columnMode ? 'MultipleBlocks' : 'ImageAndContent'}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageAndContent;
